module.exports = __webpack_public_path__ + "assets/img/NoImages@2x.399f31d9.png";